<template>
  <b-modal
    title="HISTORIAL DE AUMENTOS"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('close')"
    size="xmd"
    scrollable
    v-model="showModal"
  >
    <div class="mb-2 mt-1">
      <b-row>
        <b-col lg="12">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>NAME</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="modalData.full_name" disabled />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div class="table-responsive">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="items"
        empty-text="No se encontraron registros"
        :fields="fields"
      >
        <template #cell(fecha_vigencia)="data">
          <span style="opacity: 0.7">
            {{ data.item.fecha_vigencia | myGlobalDay }}
          </span>
        </template>
        <template #cell(created_at)="data">
          <span style="opacity: 0.7">
            {{ data.item.created_at | myGlobalDay }}
          </span>
        </template>
        <template #cell(approved_at)="data">
          <span style="opacity: 0.7">
            {{ data.item.approved_at | myGlobalDay }}
          </span>
        </template>
        <template #cell(estado)="data">
          <b-badge
            pill
            :variant="`light-${resolvStyleStatus(data.item.estado)}`"
          >
            <span> {{ $t(data.value) }} </span>
          </b-badge>
        </template>
        <template #cell(description)="data">
          <span> {{ data.value | capitalize }} </span>
        </template>
        <template #cell(observation)="data">
          <span> {{ data.value }} </span>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
/* Service */
import aumentoSueldoService from "@/views/rrhh/views/aumento-sueldo/services/aumento-sueldo.service.js";

export default {
  props: {
    modalData: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "fecha_vigencia",
          label: "Fecha vigencia",
          visible: true,
        },
        {
          key: "sueldo_base_anterior",
          label: "Sueldo base anterior",
          visible: true,
        },
        {
          key: "nuevo_sueldo_base",
          label: "Nuevo sueldo base",
          visible: true,
        },
        {
          // [1]
          key: "estado",
          label: "Estado",
          visible: true,
        },
        {
          // [1]
          key: "responsable",
          label: "Responsable",
          visible: true,
        },
        {
          // [1]
          key: "created_at",
          label: "Fecha creacion",
          visible: true,
        },
        {
          // [1]
          key: "aprobador",
          label: "Aprobado por",
          visible: true,
        },
        {
          // [1]
          key: "approved_at",
          label: "Fecha aprobacion",
          visible: true,
        },
      ],
      showModal: true,
    };
  },
  async created() {
    await this.getHistorialAumento();
  },
  computed: {
    showFields() {
      return this.fields.filter((item) => item.visible);
    },
  },
  methods: {
    async getHistorialAumento() {
      try {
        this.addPreloader();
        const { data } = await aumentoSueldoService.getHistorialAumento(
          this.modalData.id
        );
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    resolvStyleStatus(status) {
      let val = "success";
      switch (status) {
        case "pendiente":
          val = "warning";
          break;
        case "aprobado":
          val = "info";
          break;
        case "procesado":
          val = "success";
          break;
        case "anulado":
          val = "danger";
          break;
        case "rechazado":
          val = "danger";
          break;
        default:
          break;
      }
      return val;
    },
  },
};
</script>

<style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>